import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { AppState } from 'src/app/redux/app.state';
import { Manufacturer } from 'src/typings';
import { ManufacturerService } from '../manufacturer.service';

@Component({
  selector: 'app-create-manufacturer',
  templateUrl: './create-manufacturer.component.html',
  styleUrls: ['./create-manufacturer.component.scss']
})
export class CreateManufacturerComponent {
  @Input() dialogRef: MatDialogRef<CreateManufacturerComponent> | undefined;

  @Output() createEvent: EventEmitter<Manufacturer> = new EventEmitter();

  createForm: UntypedFormGroup = this.fb.group({
    description: new UntypedFormControl()
  });

  constructor(
    private manufacturerService: ManufacturerService,
    private store: Store<AppState>,
    private fb: UntypedFormBuilder
  ) {}

  get description(): string {
    return this.createForm.value.description;
  }

  get descriptionControl(): UntypedFormControl {
    return this.createForm.controls.description as UntypedFormControl;
  }

  create() {
    this.store.dispatch(setLoading({ payload: true }));
    this.manufacturerService.create({ description: this.description }).subscribe((manufacturer) => {
      this.createEvent.emit(manufacturer);
      this.store.dispatch(setLoading({ payload: false }));
      if (this.dialogRef) {
        this.dialogRef.close();
      }
    });
  }
}
